import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriversCount } from '../../services/DriversService';
import { DriversCountResponse } from '../../types/Drivers';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDriversCount(fleetId: string): UseQueryResult<DriversCountResponse> {
  return useQuery(
    ['drivers-count', fleetId],
    async (): Promise<DriversCountResponse> => getDriversCount(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetDriversCount;
